import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
}));

const Header = (props) => {
  const { className, buttonAction, titleText, add, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
        <Grid item>
          <Typography component="h2" gutterBottom variant="overline">
            {props.title}
          </Typography>
          <Typography component="h1" variant="h3">
            {props.subtitle}
          </Typography>
        </Grid>
        <Grid item>
          {add && (
            <Button
              color="primary"
              onClick={() => buttonAction()}
              variant="contained"
            >
              {titleText}
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
